module.exports = __webpack_public_path__ + "img/bc6015d.png";